var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCompleted)?_c('span',[_c('font-awesome-icon',{staticClass:"fa-fw",attrs:{"icon":['fas', 'check-circle']}}),_vm._v(" Completed ")],1):_c('span',[_vm._v(" In Progress ")])}
var staticRenderFns = []

export { render, staticRenderFns }